module.exports = __webpack_public_path__ + "static/media/3.d9a17e84.png";